<template>
  <aside class="toc-sidebar">
    <div :class="toc">
      <div
        v-for="(item, index) in toc"
        :key="index"
        :class="isSelected(item.id) && 'toc-selected'"
      >
        <a
          :href="'#' + item.id"
          @click="changeSelectedToc(item, index)"
          :class="`li1 ${isSelected(item.id) && 'itemSelected'}`"
        >
          <span>{{ item.title }}</span>
        </a>
      </div>
    </div>
  </aside>
</template>

<script>
import manual_contents from "@/assets/docs/ca2-user-manual/manual_contents.json";

export default {
  name: "ManualLeftSideBar",
  props: {
    loadManual: {
      type: Function,
      required: true,
    },
    subPath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toc: manual_contents,
      expanded: [],
      expandedSub: {},
    };
  },
  created() {
    this.checkContent();
  },
  methods: {
    checkContent() {
      this.expanded = Array(this.toc.length).fill(false);
      const mainIndex = this.toc.findIndex((item) => this.isSelected(item.id));
      const currentToc = this.toc[mainIndex];
      this.expanded[mainIndex] = true;
      const subIndex = currentToc.childs.findIndex((sub) =>
        this.isSelected(sub.id)
      );
      this.expandedSub[`${mainIndex}_${subIndex}`] = true;
      this.loadManual(currentToc.md);
    },
    toggleSection(index) {
      const isExpand = this.expanded[index];
      this.expanded = Array(this.toc.length).fill(false);
      this.$set(this.expanded, index, !isExpand);
    },
    toggleSub(mainIndex, subIndex) {
      const key = `${mainIndex}_${subIndex}`;
      if (this.expandedSub.hasOwnProperty(key)) {
        const isExpand = this.expandedSub[key];
        this.expandedSub = { key: !isExpand };
      } else {
        this.expandedSub = {};
        this.expandedSub[key] = true;
      }
    },
    isSubExpanded(mainIndex, subIndex) {
      return this.expandedSub[`${mainIndex}_${subIndex}`];
    },
    changeSelectedToc(item, index) {
      this.toggleSection(index);
      if (this.isSelected(item.id)) return;
      this.loadManual(item.md);
    },
    changeSelectedSubToc(sub, mainIndex, subIndex) {
      this.toggleSub(mainIndex, subIndex);
      if (sub.id == this.subPath) return;
    },
    isSelected(id) {
      return (
        this.subPath.startsWith("#" + id + "-") || this.subPath == "#" + id
      );
    },
  },
  watch: {
    subPath() {
      this.checkContent();
    },
  },
};
</script>

<style scoped lang="scss">
.toc-sidebar {
  width: 20%;
  padding: 0.5rem 0;
  border-right: 1px solid #00000040;
  overflow-y: auto;
  background-color: $surface-beta;
}

.toc {
  display: flex;
  flex-direction: column;
}

.toc-selected {
  background-color: $surface-gamma;
}

.li1 {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
  user-select: none;
}

.li1 {
  padding: 0.5rem 2rem;
  font-size: 14px;
}
.li1:hover {
  background-color: $border-alpha;
}

.itemSelected,
.subSelected {
  color: $surface-beta;
  border-color: $surface-beta !important;
  font-weight: 600;
}

.itemSelected {
  background-color: $primary-beta !important;
}

.expand-icon {
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  height: 20px;
  padding: 1px;
  border: 1px solid black;
}

a {
  color: inherit;
}
</style>
